/*


   TODO

   * FETCH-URL ANPASSEN!!

*/

/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { RepresentationLookup } from 'components/representationlookup'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'

import Typewriter from 'typewriter-effect/dist/core'

// TODO Set the correct article ID here
const ARTICLE_ID = '280123415833'

export function AppComponent() {
  const [title, setTitle] = useState(null)
  const [typewriter, setTypewriter] = useState(null)

  useEffect(() => {
    const tp = new Typewriter(document.querySelector('.typewriter'), {
      loop: false,
      delay: 75
    })

    const actualDomain = parseHostname().publicationName
    let texts
    if (actualDomain === 'landbote') {
      texts = ['Winterthur?', 'Turbenthal?', 'uns?']
    } else if (actualDomain === 'zuonline') {
      texts = ['Dällikon?', 'Glattfelden?', 'uns?']
    } else if (actualDomain === 'zsz') {
      texts = ['Herrliberg?', 'Horgen?', 'uns?']
    } else {
      texts = ['Winterthur?', 'Hinwil?', 'uns?']
    }

    const pauses = [500, 600]

    for (let i = 0; i < texts.length; i++) {
      tp.typeString(texts[i])

      if (i < texts.length - 1) {
        tp.pauseFor(pauses[i]).deleteChars(texts[i].length)
      }
    }

    tp.start()

    setTypewriter(tp)
  }, [])

  useEffect(() => {
    if (title && typewriter) {
      typewriter
        .stop()
        .deleteAll()
        .typeString(title + '?')
        .start()
    }
  }, [title])

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>
              Wer regiert <span className='typewriter' />
            </h1>
            <h2>
              Sie sind die lokalen Könige: Gemeinderäte. Repräsentieren sie aber
              auch die Bevölkerung? Überprüfen Sie Ihre Gemeinde.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Simon Huwiler</div>
          </div>
          <div className='ta text'>
            Wir haben von allen Zürcher Gemeinden und Städten Angaben über ihre
            Regierenden verlangt. Geben Sie Ihren Wohnort, Ihr Geschlecht, Ihr
            Alter und Ihre Partei an und wir sagen Ihnen, wie gut Sie in Ihrer
            Gemeinde vertreten werden.
          </div>
        </div>
      </div>

      <RepresentationLookup onPlaceChanged={d => setTitle(d)} />

      <Footer
        articleId={ARTICLE_ID}
        hidePortfolioTeaser
        hideUserFeedback
        credits={[
          [
            'Daten',
            'Diese Zeitung hat bei allen Gemeinden die Jahrgänge und die Parteizugehörigkeit ihrer Exekutivmitglieder erfragt. Gemeindeschreiberinnen und Gemeindeschreiber haben wir nicht berücksichtigt. Beim Alter nehmen wir jeweils an, dass der Geburtstag in diesem Jahr bereits war. Die Berechnung der Sitze pro Partei erfolgt nach dem Hagenbach-Bischoff-Verfahren. Kleinstparteien werden zu «andere Parteien» zusammengefasst. Stand der Daten: April 2021.'
          ],
          ['Entwicklung', 'Simon Huwiler']
        ]}
      >
        <div
          className='ui container'
          style={{
            margin: window.innerWidth < 600 ? '1.2em 0 3em' : '0 0 3em'
          }}
        >
          <h4 className='teaser'>Weitere Beiträge aus dieser Serie</h4>
          <ArticleTeasers
            numberOfCards='four'
            articleIds={[
              '160332428496',
              '542357290269',
              '944385039279',
              '128038806773'
            ]}
          />
        </div>
      </Footer>
    </div>
  )
}
